var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExamPassed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-groups_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "groups_2",
    "data-name": "groups \\u2013 2",
    clipPath: "url(#clip-groups_2)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_212",
    "data-name": "Ellipse 212",
    cx: 255.5,
    cy: 255.5,
    r: 255.5,
    transform: "translate(0 1)",
    fill: "rgba(33,194,98,0.15)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-check",
    "data-name": "Icon awesome-check",
    d: "M96.424,212.128,4.157,119.86a14.2,14.2,0,0,1,0-20.075L24.232,79.71a14.194,14.194,0,0,1,20.075,0l62.156,62.156L239.592,8.735a14.2,14.2,0,0,1,20.075,0L279.741,28.81a14.2,14.2,0,0,1,0,20.075L116.5,212.128A14.2,14.2,0,0,1,96.424,212.128Z",
    transform: "translate(114 146.422)",
    fill: "#21c262"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExamPassed);
export default __webpack_public_path__ + "static/media/exam-passed.e91a73a2.svg";
export { ForwardRef as ReactComponent };